// extracted by mini-css-extract-plugin
export default {"list":"i39-PlK72-wv0NHuaJOs1","item":"_3ItibNsWoVqda1SZrCR3fj"};